import React from 'react';

import CateringSignUpEmail, {
  CateringSignUpEmailProps,
} from '@/components/catering/auth/CateringSignUpEmail';
import { CateringProvider } from '@/components/shared/Provider';
import { createContainer } from '@/helpers/container_helper';

const CateringSignUpEmailEntrypoint: React.FC<CateringSignUpEmailProps> = (props) => (
  <CateringProvider>
    <CateringSignUpEmail {...props} />
  </CateringProvider>
);

createContainer('catering-sign-up-email', CateringSignUpEmailEntrypoint);
